enum DomainErrorTypes {
    VALIDATION = 'Validation',
    DATA_MISSING = 'DataMissing',
    CONNECTION = 'Connection',
    EXECUTION = 'Execution',
}

export default DomainErrorTypes;
